import React from 'react';
import './Quote.sass'

function Quote({color, children}) {
    return (
        <div className={'quote'}>
            <div className="quote__line" style={{backgroundColor: color}} />
            <div className={'quote__sentence'}>{children}</div>
        </div>
    );
}

export default Quote;